import { useCallback, useState } from 'react';

export function useThrowAsyncError() {
  const [, setError] = useState<Error | null>(null);

  const throwError = useCallback((error: Error) => {
    setError(() => {
      throw error;
    });
  }, []);

  return throwError;
}
